<template>
  <div v-if="meta" class="CollectionInfo mb-24 md:flex">
    <div class="md:w-1/4 md:mt-5">
      <h4 class="InfoTitle capitalize">Popular Searches</h4>
      <ul class="PopularSearchTerms">
        <li class="truncate" v-for="popular_search in meta.popular_searches" :key="popular_search.url">
          <a :href="popular_search.url">
            {{ popular_search.title }}
          </a>
        </li>
      </ul>
    </div>
    <div class="flex-grow mt-5 md:mx-4">
      <h4 class="InfoTitle capitalize">{{ meta.brief }}</h4>
      <p class="mt-4" v-html="meta.description">{{ meta.description }}</p>

      <a class="btn btn-primary mt-6 uppercase" :href="meta.button_link">
        {{ meta.button_label }}
      </a>
    </div>

    <div class="flex-none mt-12 md:ml-12 md:mt-5">
      <h4 class="InfoTitle capitalize">
        Top Selling {{ meta.title }} Artists
        <a v-if="userConfig.isAdmin" :href="`https://bluethumb.com.au/admin/filters/${meta.id}`" target="_blank">
          (Edit)
        </a>
      </h4>

      <ul class="InfoArtists">
        <li v-for="artist in meta.artists" :key="artist.id">
          <a :href="artist.url">
            {{ artist.name }}
          </a>
        </li>
      </ul>

      <h4 class="InfoTitle mt-12 md:mt-0">Australia's most trusted online art gallery.</h4>
      <div class="artworks-average-reviews mt-5">
        <span class="artworks-review-stars block">
          <i class="fas fa-star" v-for="x in Math.ceil(reviewScore)"></i>
        </span>
        <a href="/testimonials">{{ filterData.reviews_count }} Reviews</a>
      </div>
    </div>
  </div>
</template>

<script>
import Icon_aboriginal from "@/assets/icons/aboriginal.svg?inline"
import Icon_abstract from "@/assets/icons/abstract.svg"
import Icon_animals from "@/assets/icons/animals.svg"
import Icon_australiana from "@/assets/icons/australiana.svg"
import Icon_fantasy from "@/assets/icons/fantasy.svg"
import Icon_impressionism from "@/assets/icons/impressionism.svg"
import Icon_landscape from "@/assets/icons/landscape.svg"
import Icon_nature from "@/assets/icons/nature.svg"
import Icon_nude from "@/assets/icons/nude.svg"
import Icon_outback from "@/assets/icons/outback.svg"
import Icon_people from "@/assets/icons/people.svg"
import Icon_pop from "@/assets/icons/aboriginal.svg"
import Icon_stilllife from "@/assets/icons/stilllife.svg"
import Icon_beachart from "@/assets/icons/beachart.svg"
import { mapState } from "vuex"

export default {
  name: "CollectionInformation",
  props: ["filterData"],
  computed: {
    meta() {
      if (this.collections.length != 1) return null
      return this.metas[this.collections[0]]
    },
    reviewScore() {
      return this.filterData.reviews_average_score / 2.0
    },
    ...mapState("filter", {
      collections: ({ filters }) => filters.collections,
      metas: ({ config }) => config.meta,
    }),
  },
  components: {
    Icon_aboriginal,
    Icon_abstract,
    Icon_animals,
    Icon_australiana,
    Icon_fantasy,
    Icon_impressionism,
    Icon_landscape,
    Icon_nature,
    Icon_nude,
    Icon_outback,
    Icon_people,
    Icon_pop,
    Icon_stilllife,
    Icon_beachart,
  },
}
</script>

<style scoped>
.CollectionInfo .InfoTitle {
  font-size: 14px;
  font-weight: bold;
}

.CollectionInfo .btn-primary {
  font-weight: bold;
  border: 2px solid #089fd6;
  background-color: white !important;
  color: #089fd6 !important;
}

.CollectionInfo .InfoArtists {
  list-style: none;
  padding: 10px 0;
}

.CollectionInfo .InfoArtists li {
  padding: 1px 0;
}

.CollectionInfo .PopularSearchTerms {
  list-style: none;
  padding: 10px 0;
}

.CollectionInfo .PopularSearchTerms li {
  padding: 1px 0;
}

.CollectionInfo .artworks-average-reviews .artworks-review-stars {
  color: #f5af41;
  font-size: 16px;
}
</style>
